import React, {useCallback} from 'react'
import * as PropTypes from 'prop-types'
import {stripTrailingSlash} from '@modifi/router'
import {InferPropTypes} from '@modifi/typescript-utils'

import {prefixSlash, isExternal} from './utils'
import BasePathContext from './context'

const propTypes = {
  basePath: PropTypes.string,
  children: PropTypes.node,
}
const defaultProps = {
  basePath: undefined,
  children: null,
}

export type BasePathProviderProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const BasePathProvider: React.FC<BasePathProviderProps> = ({basePath, children}) => {
  const prependBasePath = useCallback(
    (path: string): string | undefined => {
      // external path should not be modified
      if (isExternal(path)) {
        return path
      }
      // in case we don't have a base path don't return anything to prevent broken links
      if (typeof basePath !== 'string') {
        return undefined
      }
      return stripTrailingSlash(`${prefixSlash(basePath)}${prefixSlash(path)}`)
    },
    [basePath]
  )

  const value = {
    prependBasePath,
    basePath,
  }

  return <BasePathContext.Provider value={value}>{children}</BasePathContext.Provider>
}

BasePathProvider.propTypes = propTypes
BasePathProvider.defaultProps = defaultProps

export default BasePathProvider
